<app-modal-main class="online-form-accessories-modal">
  <app-modal-main-content>
    @if (data) {
      <app-modal-header>
        @if (data.title) {
          <app-modal-title>{{ data.title }}</app-modal-title>
        }
        @if (data.description) {
          <app-paragraph [font-size]="'small'">{{ data.description }}</app-paragraph>
        }
      </app-modal-header>
      @if (data.image) {
        <app-image [src]="data.image" [width]="476" [height]="357"></app-image>
      }
    }
  </app-modal-main-content>
</app-modal-main>
